/**
 * Anonymous and auth user can see the quiz and navigate to quiz landing page
 *
 * @module views/components/TakeAQuiz
 * @memberof -Common
 */
import React from 'react';

import PropTypes from 'prop-types';

import { spreadProps } from '@ulta/core/utils/dom/dom';

import CompactCard from '../CompactCard/CompactCard';

/**
  * Represents a TakeAQuiz component
  *
  * @method
  * @param {TakeAQuizProps} props - React properties passed from composition
  * @returns TakeAQuiz
  */
export const TakeAQuiz = function( props ){
  const { title, subtitle, action, ...rest } = props;

  const titleObj = {
    ...title,
    textStyle: 'title-6'
  };

  return (
    action.url &&
      <CompactCard
        { ...spreadProps( { ...rest } ) }
        title={ titleObj }
        subtitle={ subtitle }
        backgroundColor='orange-100'
        linkAction={ action }
      />
  );
};

/**
  * Property type definitions
  * @typedef TakeAQuizProps
  * @type {object}
  * @property {object} title - Sets the title for display
  * @property {object} action - Sets the actionLabel for display
  * @property {string} subtitle - Sets the subtitle for display
  */
export const propTypes =  {
  /** Sets the title for display */
  title: PropTypes.object,
  /** Sets the actionLabel for display */
  action:PropTypes.object,
  /** Sets the subtitle for display */
  subtitle:PropTypes.string
};



TakeAQuiz.propTypes = propTypes;

export default TakeAQuiz;
